import { type Event } from './types';
import { sendEvents } from '~shared/lib/analytics/src/sendEvents';
import { type ReduxDispatch } from '~shared/types';

export const EVENTS_GENERATED = 'EVENTS_GENERATED';

type EventsGenerated = {
  type: typeof EVENTS_GENERATED;
  payload: Event[];
};
export const eventsGenerated = (events: Event[]): EventsGenerated => {
  return {
    type: EVENTS_GENERATED,
    payload: events,
  };
};

export const EVENTS_FLUSHED_SUCCEEDED = 'EVENTS_FLUSHED_SUCCEEDED';

function eventsFlushedSucceeded(events: Event[]) {
  return {
    type: EVENTS_FLUSHED_SUCCEEDED,
    payload: {
      events,
    },
  };
}

export const EVENTS_FLUSHED_FAILED = 'EVENTS_FLUSHED_FAILED';

function eventsFlushedFailed() {
  return {
    type: EVENTS_FLUSHED_FAILED,
  };
}

export const EVENTS_FLUSH_STARTED = 'EVENTS_FLUSH_STARTED';

function eventsFlushStarted() {
  return {
    type: EVENTS_FLUSH_STARTED,
  };
}

export function flushAnalyticsEvents(events: Event[]) {
  return async (dispatch: ReduxDispatch) => {
    dispatch(eventsFlushStarted());

    try {
      const json = await sendEvents(events);
      if (!json) {
        dispatch(eventsFlushedFailed());
        return;
      }
      if (json.error) {
        dispatch(eventsFlushedFailed());
      } else {
        dispatch(eventsFlushedSucceeded(events));
      }
    } catch {
      // Network failures (e.g. offline, request cancelled on logout) are expected
      // and should not surface as unhandled rejections in Sentry.
      dispatch(eventsFlushedFailed());
    }
  };
}

export const sendAnalyticsEvent = (event: Event) => (dispatch: ReduxDispatch) => {
  dispatch(eventsGenerated([event]));
};
